<template>
	<v-container fluid align-start ma-0 pa-2 class="container-height">
		<v-row no-gutters fill-height>
			<v-col cols="12">
				<i-card-vertical :headerTitle="menuTitle" 
					:useBtnList="useBtnList"
					@btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnSendRequest="btnSendRequest()"
				>
					<template v-slot:body>
						<v-row>
							<v-col cols="12" class="pa-0">
								<i-card-top
									class="d-md-flex"
									outlined
								>
									<template v-slot:body>
										<v-row no-gutters class="center pa-0 pl-1">
											<v-col cols="12">
												<v-row dense>
													<i-label :label="'Supplier name : '"/>
													<v-col cols="4">
														<v-select
															v-model="supName"
															:items="supNameList"
															item-value="supName"
															return-object
															single-line
															outlined
															dense
															@change="supNameChange"
														></v-select>
													</v-col>

												</v-row>
												<v-row dense class="ma-0">
													<i-label :label="'Ship No : '"/>
													<v-col cols="1">
														<v-select
															v-model="shipNo"
															:items="shipNoList"
															item-value="shipNo"
															return-object
															single-line
															outlined
															dense
                                                            @change="btnRetrieve"
														></v-select>
													</v-col>
													<i-label :label="'Block : '" class="pl-2"/>
													<v-col cols="1">
														<v-text-field
                                                           dense 
                                                           outlined 
                                                           hide-details="auto"
                                                           clearable 
                                                           maxLength="4"
                                                           v-model="block"
														   @keyup.enter="btnRetrieve()"
                                                        />
													</v-col>
													<v-col align="right">
														<span class="pa-2 pt-1 pb-1 gubun1">Finish Block</span>
														<span class="pa-2 pt-1 pb-1 gubun2">Block Delay</span>
														<span class="pa-2 pt-1 pb-1 gubun3">DIM Request</span>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</template>
								</i-card-top>
							</v-col>
						</v-row>

						<v-row no-gutters>
							<v-col cols="12" class="pt-1">
								<DxDataGrid id="v80a1070" 
									:ref="v80a1070Ref"
									class="listBox04"
									:data-source="gridMainList" 
									:remote-operations="false" 
									:hover-state-enabled="true"
									:allow-column-resizing="true" 
									:allow-column-reordering="true"
									:row-alternation-enabled="true" 
									:show-borders="true" 
									:width="grid.width"
									:show-row-lines="true" 
									key-expr="id" 
									:focused-row-enabled="false"
									:column-hiding-enabled="false" 
									:sorting="{ mode: 'none' }"
                                    :selection="{ mode: 'none' }"
									@cellPrepared="cellPrepared"
									@editing-start="onEditingStart"
								> 

									<DxColumn data-field="selChek" caption="Sel" data-type="boolean" width="2%" cell-template="selChkRow" :allow-editing="false" />
									<template #selChkRow = "{ data: cellInfo }">
										<DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="cellInfo.data.inspYn === 'Y' || cellInfo.data.urgentYn === 'Y' ? true : false" 
											:onValueChanged="value => onValueChanged(value, cellInfo)" />
									</template> 

                  <DxColumn data-field="block" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="wkVol" caption="Weight" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="respNm" caption="Work Group" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn caption="Mid P.P" data-type="string" alignment="center" :allow-editing="false" >
                    <DxColumn data-field="midppPsd" caption="Start" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="midppPfd" caption="Finish" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="midPer" caption="Dur" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                  </DxColumn>
                  <DxColumn data-field="progRate" width="5%" data-type="string" header-cell-template="rate" alignment="center" :allow-editing="false"/>
                  <template #rate >
                    <div>
                      <span>Prog<br>Rate(%)</span>
                    </div>
                  </template>
                  <DxColumn data-field="reqDate" width="7%" data-type="date" format="yyyy-MM-dd" header-cell-template="requestDate" alignment="center" 
										:set-cell-value="reqDateChanged" :allow-editing="true"/>
                  <template #requestDate >
                    <div>
                      <span>Request<br>Inspection<br>date</span>
                    </div>
                  </template>
                  <DxColumn data-field="reqTime" caption="Req Time" width="5%" data-type="string" alignment="center" :allow-editing="true" :set-cell-value="reqTimeChanged" >
                    <DxLookup :data-source="reqTimeList" display-expr="timeNm" value-expr="codeName"/>
                  </DxColumn>
                  <DxColumn data-field="insDate" width="7%" data-type="date" format="yyyy-MM-dd" header-cell-template="inspectionDate" alignment="center" :allow-editing="true"/>
                  <template #inspectionDate >
                    <div>
                      <span>Inspection<br>date</span>
                    </div>
                  </template>
                  <DxColumn data-field="insTime" caption="Insp Time" width="5%" data-type="string" alignment="center" :allow-editing="true">
                    <DxLookup :data-source="insTimeList" display-expr="timeNm" value-expr="codeName" />
                  </DxColumn>
                  <DxColumn data-field="pic" caption="P.I.C(PP-DIM)" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                  <DxColumn data-field="prodYn" caption="Insp(Y/N)" width="7%" data-type="boolean" alignment="center" :allow-editing="false" edit-cell-template="inspYn"/>
                  <template #inspYn="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :disabled="isDisabledInsp" :onValueChanged="value => onValueChanged2(value, cellInfo)" />
                  </template>
                  <DxColumn data-field="rstCd" caption="Remark(Reason)" width="20%" data-type="string" alignment="center" :allow-editing="false"/>

									<DxPaging :enabled="true" :page-size="17" />
                  <DxPager :visible="true" :showInfo="false" />
								</DxDataGrid>
							</v-col>
						</v-row>
						<v-row no-gutters>
              <v-col cols="12" class="subText">Count Total: {{ listSize }} Row(s)</v-col>
						</v-row>

					</template>
				</i-card-vertical>
			</v-col>
		</v-row>
	</v-container>
</template>
	
<script>
import { DxDataGrid, DxEditing, DxColumn , DxLookup, DxSelection, DxPager } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getSupplier , getV80ShipNo , getRespMaker } from '@/api/view/hip/8/v80a1040.js'
import { v80ReqTime , v80a1070List , v80a1070Save } from '@/api/view/hip/8/v80a1070.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { reportView} from '@/api/view/hip/common/common.js'
import notify from 'devextreme/ui/notify' // message
import dayjs from 'dayjs';

export default {
	name: 'v80a1070',
	mixins: [baseview, BaseDataGrid],
	components: {
		ICardVertical,
		"i-card-top": iCardTop,
		DxDataGrid,
		DxColumn,
		DxEditing,
		DxLookup,
		DxSelection,
		DxPager
	},
	watch : {
		// money(newValue, oldValue){
		// 		console.log(newValue, oldValue);
		// }
	},
	data() {
		return {
			menuTitle: this.$route.meta.title,
			useBtnList: ['btnRetrieve','btnSendRequest' , 'btnPrint' ],
			v80a1070Ref: 'v80a1070Ref',
			gridMainList: [],

			supName: '',
			supNameList: [],
			shipNo: '',
			shipNoList: [],
			block: '',
			custCd: '',
			respCd: '',

			reqTimeList: [],
			insTimeList: [],

			listSize: 0,
			isDisabledInsp: false,

		}
	},
	computed: {
		gridMainInstance() {
			return this.GetDataGrid(this.v80a1070Ref)
		},
	},
	beforeMount(){
		let params = {
			makerCd: this.$store.state.user.makerCd,
			code: '',
			codegr: '',
			prtCode: 'TIME_INSP',
			userFlag: 'Y',
		}
		//inspTimeList , reqTimeList
		Promise.all([
		getCmChildCode(params)]).then(res => {
			res[0].list.forEach(e => {
				if(e.codeName != null){
					e.timeNm = e.codeName.substring(0,2) + ':' +  e.codeName.substring(2)
				} else {
					e.timeNm = ''
				}
			});
			this.insTimeList = res[0].list
			this.reqTimeList = res[0].list
		}).catch(error => {}) 
	},
	mounted() {
		this.init()
		this.gridMainInstance.option('defaultPaging', false)
	},
	methods: {
		init(){
			if(this.$store.state.user.userGrd === '1'){
				isDisabledInsp = true
			}
			this.getList()

			if (this.$store.state.user.userGrd !== 'A'){
				this.supNameChange()
			}
		},
		async getList(){
			try {
				this.openLoading('searching')
				let params = {
					// makerCd: this.$store.state.user.userGrd !== 'A' ? this.custCd : '%',
					makerCd: this.$store.state.user.userGrd !== 'A' ? this.$store.state.user.makerCd : '%',
					code: '',
					codegr: '',
					prtCode: 'INSP_DIV',
					userFlag: 'Y',
					shipGu: ''
				}

				await getSupplier(params).then(res => {
					// this.supNameList.push('Select Supplier')
					if (this.$store.state.user.userGrd == 'A') {
						this.supNameList.push('Select Supplier')
					}  
					res.list.forEach(e => {
						this.supNameList.push(e.custCd + ' : ' + e.custNm)
					});
					this.supName = this.supNameList[0]
				})

				getV80ShipNo(params).then(res => {
					this.shipNoList.push('All')
					res.list.forEach(e => {
						this.shipNoList.push(e.shipNo)
					});
					this.shipNo = this.shipNoList[0]
				})
			} finally {
				this.endLoading()
			}
		},
		async getMainList(){
			try {
				this.openLoading('searching')
				let params = {
					shipNo: this.shipNo === 'All' ? '' : this.shipNo ,
					block: this.block ,
					makerCd: this.custCd
				}
				await v80a1070List(params).then(res => {
					res.list.forEach(e => {
						e.id = e.rnum 
						e.selChek = 'N'
					});
					this.gridMainList = res.list
					this.listSize = res.list.length
				})
				await getRespMaker(params).then(res => {
					this.respCd = res.list[0].respCd
				})

			} finally {
			this.endLoading()
			}
		},
		supNameChange(){
			let supNameGbn = this.supName
			supNameGbn = supNameGbn.split(' : ')
			if (this.$store.state.user.userGrd !== 'A') {
				this.custCd = this.$store.state.user.makerCd 
			}
			else{
				this.custCd = supNameGbn[0]
			}

			// this.custCd = supNameGbn[0]	
		},
		btnRetrieve(){
			if(!this.custCd){
				this.vToastify(this.$t('Please, Select Supplier to Retrieve!'), 'warn')
				return
			}
			if(this.custCd !== '14017' ){
				this.vToastify(this.$t('Sorry!, This program apply for Jeil Vina NT only!'), 'warn')
				return
			}
			if(this.shipNo === 'All'){
				this.vToastify(this.$t('Please, Select Ship No to Retrieve!'), 'warn')
				return
			}
			this.getMainList()
		},
		async btnSendRequest(){
			if(this.custCd !== '14017' ){
				this.vToastify(this.$t('Sorry!, This program apply for Jeil Vina NT only!'), 'warn')
				return
			}
			await this.gridMainInstance.saveEditData()
			var selectedMainRows = await this.gridMainInstance.getSelectedRowsData()

			if(!selectedMainRows.length){
				this.vToastify(this.$t('Please, Select checkbox for request items.'), 'warn')
				return
			}

			let toDay = new Date()
			toDay.setDate(toDay.getDate() + 0);
			// toDay = dayjs(toDay).format('YYYY-MM-DD')
			
			for(var row of selectedMainRows){
				// console.log('reqDate :', row.reqDate)
				// console.log('toDay :', toDay)
				let _reqDate = dayjs(row.reqDate).format('YYYY-MM-DD')
				if(!row.reqDate){
					this.vToastify(this.$t('Please, Select Request Inspection Date.'), 'warn')
					return
				}
				if(!row.reqTime){
					this.vToastify(this.$t('Please, Select Request Inspection Time.'), 'warn')
					return
				}
				if(row.reqDate < toDay){
					this.vToastify(this.$t('You cannot request the inspection of this day. You select Request Date over today please!'), 'warn')
					return
				}
				row.respCd = this.respCd
				row.userId = this.$store.state.user.userId
				row.reqDate = dayjs(row.reqDate).format('YYYY-MM-DD')
				row.insDate = dayjs(row.insDate).format('YYYY-MM-DD')
			}			

			v80a1070Save(selectedMainRows).then(res => {
				this.openLoading('searching')
				if(res.body === 'Y'){
					notify(this.$t('Request is completed.'), 'success', 3000)
				} else {
					this.vToastify(this.$t('An error was occured :' + res.body), 'warn')
				}
			}).finally(() => {
				this.endLoading()
				this.getMainList()
			})
		},
		btnPrint(){
			if(!this.custCd){
				this.vToastify(this.$t('Please, Select Customer to Retrieve!'), 'warn')
				return
			}
			if(!this.shipNo){
				this.vToastify(this.$t('Please, Select Ship No to Retrieve!'), 'warn')
				return
			}
			const param = {
				fileName: 'v80a1070.jrxml',
				as_ship_no: this.shipNo,
				as_block: this.block,
				as_maker_cd: this.$store.state.user.makerCd
			}
			this.openLoading('searching')
			reportView(param)
			.finally(() => {
				this.endLoading()
			})
		},
		reqDateChanged(newData , value , currentRowData){
			newData.reqDate = value
			newData.insDate = value
			this.gridMainInstance.refresh()
		},
		reqTimeChanged(newData , value , currentRowData){
			newData.reqTime = value
			newData.insTime = value
			this.gridMainInstance.refresh()
		},
		onValueChanged(value, cellInfo){
			cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
			if(cellInfo.value === 'N'){
				cellInfo.component.selectRows([cellInfo.row.key], true)
			} else {
				cellInfo.component.deselectRows([cellInfo.row.key], true)
			}
			cellInfo.component.updateDimensions()
		},
		onValueChanged2(value, cellInfo){
			cellInfo.component.cellValue(cellInfo.rowIndex, cellInfo.columnIndex, cellInfo.value === 'Y' ? 'N' : 'Y')
			cellInfo.component.updateDimensions()
		},
		onEditingStart(e){
			if(e.column.dataField === 'reqDate' || e.column.dataField === 'reqTime' || e.column.dataField === 'insDate' || e.column.dataField === 'insTime'){
				if(e.data.inspYn === 'Y' || e.data.urgentYn === 'Y' ) {
					e.cancel = true
				}
			}
		},
		//cell merge ,color
		cellPrepared(e){
			if(e.rowType === 'data'){
				if(e.column.dataField === 'block' || e.column.dataField === 'wkVol' || e.column.dataField === 'respNm' || e.column.dataField === 'midppPsd'
						|| e.column.dataField === 'midppPfd' || e.column.dataField === 'midPer'){
					if(e.row.data.passYn === 'Y'){
						e.cellElement.style.backgroundColor = '#00FF00'
					} else {
						if(e.row.data.dlyYn === 'Y'){
							e.cellElement.style.backgroundColor = '#FF0000'
						} else {
							if(e.row.data.reqYn === 'Y'){
								e.cellElement.style.backgroundColor = '#FFFF00'
							}
						}
					}
				}

				if(e.column.dataField === 'reqDate' || e.column.dataField === 'reqTime' || e.column.dataField === 'insDate' 
						|| e.column.dataField === 'prodYn' || e.column.dataField === 'insTime'){
					if(e.row.data.passYn === 'Y' || e.row.data.inspYn === 'Y' ){
						e.cellElement.style.backgroundColor = '#00FF00'
					} else {
						if(e.row.data.reqYn === 'Y'){
							e.cellElement.style.backgroundColor = '#FFFF00'
						}
					}
				}
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.subText{
	font-weight: bold;
	color: black;
}
.gubun1 {
	background-color: #00FF00;
	font-weight: bold;
}
.gubun2 {
	background-color: #FF0000;
	font-weight: bold;
}
.gubun3 {
	background-color: #FFFF00;
	font-weight: bold;
}
</style>